<div class="auth-page-container">
    <div class="auth-card">
      <div class="auth-icon">
        <i class="ri-lock-password-line"></i>
      </div>
      <h2 class="auth-title">Réinitialiser le mot de passe</h2>
  
      <p class="welcome-text">
        Choisissez un nouveau mot de passe sécurisé 🔐
      </p>
  
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="auth-form">
        <div class="form-group">
          <label>Nouveau mot de passe</label>
          <input type="password" class="form-control" placeholder="Nouveau mot de passe" formControlName="password" />
          <div *ngIf="form.get('password')?.touched">
            <div *ngIf="form.get('password')?.hasError('minlength')" class="text-danger small mt-1">
              Le mot de passe doit contenir au moins 6 caractères.
            </div>
            <div *ngIf="form.get('password')?.hasError('passwordWeak')" class="text-danger small mt-1">
              Le mot de passe doit contenir une majuscule et un caractère spécial.
            </div>
          </div>
        </div>
  
        <div class="form-group mt-3">
          <label>Confirmer le mot de passe</label>
          <input type="password" class="form-control" placeholder="Confirmer le mot de passe" formControlName="confirmPassword" />
          <div *ngIf="form.hasError('passwordsMismatch') && form.get('confirmPassword')?.touched" class="text-danger small mt-1">
            Les mots de passe ne correspondent pas.
          </div>
        </div>
  
        <button type="submit" class="btn btn-success mt-3 w-100" [disabled]="form.invalid">
          Valider
        </button>
  
        <p *ngIf="success" class="text-success mt-3 text-center">
          ✅ Votre mot de passe a été mis à jour. Vous pouvez maintenant vous connecter.
        </p>
        <p *ngIf="error" class="text-danger mt-3 text-center">
          ❌ {{ error }}
        </p>
      </form>
  
      <div class="text-center mt-3">
        <a routerLink="/sign-in" class="forgot-link">← Retour à la connexion</a>
      </div>
    </div>
  </div>
  